import { AwaitActionDialog } from "../../Dialogs/AwaitActionDialog";

const CreatePdfDialog = ({ open }: { open: boolean; }) => {
  return <AwaitActionDialog open={open} title={`PDF wird erstellt`} />;
};

export default CreatePdfDialog;
